import React, { forwardRef, useState } from "react";
import clsx from "clsx";
import styles from "./styles.module.css";

interface ImageProps {
  className?: string;
  src: string;
  alt: string;
  title?: string;
  style?: React.CSSProperties;
  fallbackSrc?: string;
}

const ImageComponent = forwardRef<HTMLImageElement, ImageProps>(
  ({ className, src, alt, title, fallbackSrc, style }, ref) => {
    const [currentSrc, setCurrentSrc] = useState(src);

    const handleError = () => {
      if (fallbackSrc) {
        setCurrentSrc(fallbackSrc);
      }
    };

    return (
      <img
        className={className}
        src={currentSrc}
        alt={alt}
        title={title}
        width="100%"
        height="100%"
        loading="lazy"
        decoding="async"
        ref={ref}
        style={style}
        onError={handleError}
      />
    );
  }
);

export default ImageComponent;
